import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CustomNavbar from "./navbar";
import Infracciones from "./infracciones";
import Motivacion from "./motivacion";
import Infractor from "./infractor";
import Fotografias from "./fotografias";
import MisInfracciones from "./misinfracciones";
import LoadingOverlay from "./LoadingOverlay";
import { fetchCurrentUser } from "../services/api";
import { getStoredUser, setSessionData } from "../utils/session";

export default function MainPage({ onLogout }) {
    const navigate = useNavigate();
    const [activePage, setActivePage] = useState("infracciones");
    const [isAdmin, setIsAdmin] = useState(false);
    const [loading, setLoading] = useState(true);  // Añadir estado de carga

    useEffect(() => {
        async function checkUserRole() {
            setLoading(true);

            let currentUser = getStoredUser();

            try {
                const userFromApi = await fetchCurrentUser();
                if (userFromApi) {
                    currentUser = userFromApi;
                    setSessionData(userFromApi);
                }
            } catch (error) {
                console.warn("No se pudo refrescar el usuario actual:", error);
            }

            setIsAdmin(currentUser?.rol === "admin" || currentUser?.rol === "director");

            if (currentUser?.rol === "admin" || currentUser?.rol === "director") {
                navigate("/adminpage");
                return;
            }

            setTimeout(() => {
                setLoading(false);
            }, 800);
        }

        checkUserRole();
    }, [navigate]);

    if (loading) {
        return <LoadingOverlay />;
    }

    return (
        <div>
            <CustomNavbar activePage={activePage} setActivePage={setActivePage} onLogout={onLogout} isAdmin={isAdmin} />
            <div className="content">
                {activePage === "infracciones" && <Infracciones setActivePage={setActivePage} />}
                {activePage === "motivacion" && <Motivacion setActivePage={setActivePage} />}
                {activePage === "infractor" && <Infractor setActivePage={setActivePage} />}
                {activePage === "fotografias" && <Fotografias setActivePage={setActivePage} />}
                {activePage === "misinfracciones" && <MisInfracciones />}
            </div>
        </div>
    );
}
